import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AuthService } from '../../services/auth.service';

const ProtectedRoute = () => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();

    // Check both authentication state and token validity
    if (!isAuthenticated || !AuthService.isValidToken()) {
        // Save the attempted location, including the query string so deep links with
        // params (e.g. /goods-receipts/new?purchaseOrderId=...) survive the login bounce.
        return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
